/* PACKO · Carry-on Only: motion.
   - reveals headings, cards and photos as they scroll in (styles in
     packo-carryon-motion.css). Only what is still below the screen when
     this runs is hidden first; what the visitor already sees is left alone.
     Reviews shown later ("more reviews") and sections re-rendered by
     Shopify are picked up the same way.
   - a swipe row (the comparison cards on phones) is revealed as one, when
     the row comes into view, so a card swiped in later is never empty
   - turns the stats into a departure board: each digit flips through
     random numbers before landing on the real one. The tiles are built
     while the row is still off screen, so nothing changes size in view.
   - counts the kg figures up from zero
   - draws a thin yellow progress meter along the top of the window
   Runs only when <head> added html.pc-motion (motion allowed, not the
   theme editor). */
(function () {
  var root = document.documentElement;
  window.__pcMotion = true;
  if (!root.classList.contains('pc-motion') || !('IntersectionObserver' in window)) return;

  var KINDS = [
    ['pc-w--vac', '.packo-h2:not(.packo-steps__title),.pa__title,.packo-split__title,.packo-stats__title,.pkc__title'],
    ['pc-w--seal', '.packo-step__media,.pa__media,.packo-split__media'],
    ['pc-w--rise', '.packo-rvh__summary,.packo-rvh__write,.packo-step,.pa__item,.pa__total,.pa__vs-card,.pa__trial,.packo-rv,.packo-faq__item,.packo-stat,.packo-split__panel,.packo-cmp__table,.packo-cmp-card,.packo-pdp__feature']
  ];
  var ALL = KINDS.map(function (k) { return k[1]; }).join(',');
  var DIGITS = '0123456789';
  var seen = new WeakSet();
  var rows = new Map(); /* swipe row -> its waiting items */

  function kindOf(el) {
    for (var i = 0; i < KINDS.length; i++) if (el.matches(KINDS[i][1])) return KINDS[i][0];
    return null;
  }

  function onScreen(r) {
    return (r.width > 0 || r.height > 0) && r.bottom > 0 && r.top < (window.innerHeight || root.clientHeight);
  }

  function swipeRow(el) {
    var p = el.parentElement;
    if (!p) return null;
    var ox = getComputedStyle(p).overflowX;
    return ox === 'auto' || ox === 'scroll' ? p : null;
  }

  var io = new IntersectionObserver(function (entries) {
    var n = 0;
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      io.unobserve(e.target);
      var items = rows.get(e.target);
      if (items) {
        rows.delete(e.target);
        items.forEach(function (el) { reveal(el, n++); });
      } else {
        reveal(e.target, n++);
      }
    });
  }, { threshold: 0, rootMargin: '0px 0px -6% 0px' });

  function reveal(el, n) {
    el.style.setProperty('--pc-d', (Math.min(n, 4) * 0.08).toFixed(2) + 's');
    el.classList.add('is-in');
    if (el.classList.contains('packo-stat')) flap(el);
    if (el.classList.contains('pa__item') || el.classList.contains('pa__total')) countUp(el);
  }

  /* Reads first (positions, styles), then writes, so this costs one layout. */
  function prepare(list) {
    var info = list.map(function (el) {
      var row = swipeRow(el);
      return {
        el: el,
        kind: kindOf(el),
        row: row,
        rect: (row || el).getBoundingClientRect()
      };
    });
    info.forEach(function (it) {
      if (!it.kind || onScreen(it.rect)) return;
      var el = it.el;
      el.classList.add('pc-w', it.kind);
      if (el.classList.contains('packo-stat')) board(el);
      if (it.row) {
        if (!rows.has(it.row)) { rows.set(it.row, []); io.observe(it.row); }
        rows.get(it.row).push(el);
      } else {
        io.observe(el);
      }
    });
  }

  function collect(scope, out) {
    if (scope.matches && scope.matches(ALL) && !seen.has(scope)) { seen.add(scope); out.push(scope); }
    if (!scope.querySelectorAll) return out;
    scope.querySelectorAll(ALL).forEach(function (el) {
      if (seen.has(el)) return;
      seen.add(el);
      out.push(el);
    });
    return out;
  }

  prepare(collect(document, []));
  new MutationObserver(function (list) {
    var found = [];
    list.forEach(function (m) {
      m.addedNodes.forEach(function (node) { if (node.nodeType === 1) collect(node, found); });
    });
    if (found.length) prepare(found);
  }).observe(document.body, { childList: true, subtree: true });

  /* Departure board. Digit runs stay left-to-right inside the Hebrew line,
     so "400 ₪" and "3+" keep the order the shop typed. Skipped when the
     stats section's own count-up is switched on (it marks the number with
     role="img" before this script runs). */
  function board(stat) {
    var num = stat.querySelector('.packo-stat__num');
    if (!num || num.dataset.pcFlap || num.getAttribute('role') === 'img') return;
    num.dataset.pcFlap = '1';
    var text = num.textContent.trim();
    num.setAttribute('role', 'img');
    num.setAttribute('aria-label', text);
    num.classList.add('pc-board');
    num.textContent = '';
    var run = null;
    Array.from(text).forEach(function (ch) {
      if (ch === ' ') {
        run = null;
        var gap = document.createElement('span');
        gap.className = 'pc-flapgap';
        num.appendChild(gap);
        return;
      }
      var t = document.createElement('span');
      t.className = 'pc-flap';
      t.setAttribute('aria-hidden', 'true');
      t.textContent = ch;
      t.dataset.ch = ch;
      if (/[0-9.,%]/.test(ch)) {
        if (!run) { run = document.createElement('span'); run.className = 'pc-flaprun'; num.appendChild(run); }
        run.appendChild(t);
      } else {
        run = null;
        num.appendChild(t);
      }
    });
  }

  function flap(stat) {
    var tiles = stat.querySelectorAll('.pc-board .pc-flap');
    Array.prototype.forEach.call(tiles, function (t, i) {
      if (!/[0-9]/.test(t.dataset.ch)) return;
      var start = performance.now();
      var end = start + 550 + i * 160;
      var last = 0;
      (function tick(now) {
        if (now >= end) { t.textContent = t.dataset.ch; t.classList.add('is-set'); return; }
        if (now - last > 60) { t.textContent = DIGITS.charAt(Math.floor(Math.random() * 10)); last = now; }
        requestAnimationFrame(tick);
      })(start);
    });
  }

  /* Whole numbers only; the box keeps the final width from the first frame
     so the unit beside it does not shift while the digits count. */
  function countUp(el) {
    el.querySelectorAll('.pa__kg b').forEach(function (b) {
      var text = b.textContent.trim();
      if (!/^[0-9]+$/.test(text) || b.dataset.pcCount) return;
      b.dataset.pcCount = '1';
      var target = parseInt(text, 10);
      b.style.display = 'inline-block';
      b.style.minWidth = text.length + 'ch';
      b.style.textAlign = 'end';
      var t0 = null;
      var dur = 900;
      (function frame(now) {
        if (t0 === null) t0 = now;
        var p = Math.min((now - t0) / dur, 1);
        b.textContent = p < 1 ? Math.round(target * (1 - Math.pow(1 - p, 3))) : text;
        if (p < 1) requestAnimationFrame(frame);
      })(performance.now());
    });
  }

  var bar = document.createElement('div');
  bar.className = 'pc-progress';
  bar.setAttribute('aria-hidden', 'true');
  document.body.appendChild(bar);
  var ticking = false;
  function update() {
    var h = root.scrollHeight - window.innerHeight;
    bar.style.transform = 'scaleX(' + (h > 0 ? Math.min(window.scrollY / h, 1) : 0) + ')';
    ticking = false;
  }
  function queue() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }
  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('resize', queue, { passive: true });
  update();
})();